<template>
  <v-select
    v-hotkey="keymap"
    v-model="select"
    :items="stores"
    item-text="name"
    item-value="code"
    prepend-icon="bubble_chart"
    class="store-select"
    @change="changeStore"
  />
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'SelectBrand',

  data () {
    return {
      select: ''
    }
  },

  computed: {
    keymap () {
      return {
        'meta+b': this.toggle
      }
    },
    ...mapGetters(['stores'])
  },

  async mounted () {
    this.select = localStorage.getItem('store-code') || ''
    this.select ? this.setStore(this.select) : this.toggle()
    await this.setDefaultCurrency()
    await this.setDefaultLocale()
    await this.setFetchingStoresStatus(false)
  },

  methods: {
    ...mapActions(['setStore', 'setFetchingStoresStatus', 'setCurrency', 'setLocale']),

    toggle () {
      const index = this.stores.findIndex(obj => obj.code === this.select)
      if (index < this.stores.length - 1) {
        this.select = this.stores[index + 1].code
      } else {
        this.select = this.stores[0].code
      }
      this.setStore(this.select)
    },

    async setDefaultCurrency () {
      try {
        const currency = await this.$http.make('general_settings').find('currency')
        if (currency.default) {
          this.setCurrency(currency.default)
        }
      } catch (error) {
        console.error(error.message)
      }
    },

    async setDefaultLocale () {
      try {
        const locale = await this.$http.make('general_settings').find('locale')
        if (locale.default) {
          this.setLocale(locale.default)
        }
      } catch (error) {
        console.error(error.message)
      }
    },

    changeStore (store) {
      this.$router.push({ name: 'orders' })
      this.setStore(store)
      this.$radio.$emit('store-change')
    }
  }
}
</script>

<style lang="stylus">
  .store-select .v-input__slot {
    margin-bottom: 0
    position: static
  }
</style>
